import { ENTITY_TYPES } from '@sales-center/common'
import { useMemo } from 'react'
import {
  DateRange,
  LimitedDate,
  MultiSelect,
  Nullable,
  SingleSelect,
  ValueRange,
  Ternary,
} from '../../typings'
import {
  getDateRangeSubLabel,
  getMultipleSelectSubLabel,
  getNullableSubLabel,
  getValueRangeSubLabel,
  getSingleSelectSubLabel,
  getLimitedDateSubLabel,
  getTernarySubLabel,
} from '../functionsGetFilterLabel'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

export function useGetSubLabel(
  typeName: string,
  value: unknown,
  entityType?: ENTITY_TYPES,
  filterId?: string,
  salesTeamCount?: number,
) {
  const { formatDate } = useLocalizationDateFormat()
  return useMemo(() => {
    switch (typeName) {
      case 'dateRange': {
        return getDateRangeSubLabel(value as DateRange, formatDate)
      }
      case 'multiSelect': {
        return getMultipleSelectSubLabel(
          value as MultiSelect,
          filterId,
          salesTeamCount,
        )
      }
      case 'nullable': {
        return getNullableSubLabel(value as Nullable, entityType)
      }
      case 'valueRange': {
        return getValueRangeSubLabel(value as ValueRange)
      }
      case 'singleSelect': {
        return getSingleSelectSubLabel(value as SingleSelect)
      }
      case 'limitedDate':
        return getLimitedDateSubLabel(value as LimitedDate)
      case 'ternary':
        return getTernarySubLabel(value as Ternary)
      default: {
        return ''
      }
    }
  }, [typeName, value, entityType, filterId, salesTeamCount])
}
